import React from 'react';
import SummaryTournament from './SummaryTournament';
import Image from 'react-bootstrap/Image';


class Camisetas extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      showCards: true,
	kit_path: '/images/kits/todas/',
	kits: [],
      id_list: []
    };
  }

  componentDidMount(){ 

    for(var i= 117; i <= 1303; i++){
		this.state.id_list.push(i);
	}

	this.getKits();
  }

getKits(){

        fetch("https://www.registrosudec.com:5000/onlykits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", soc$
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}

  render(){



 // Remove any existing entries with path 200 or 300
this.state.kits = this.state.kits.filter(
  k => k.path !== 200 && k.path !== 300
);

// Find index of path 17
const index17 = this.state.kits.findIndex(k => k.path === 17);
// Find index of path 18
const index18 = this.state.kits.findIndex(k => k.path === 18);

// Insert 200 and 300 between path 17 and 18
if (index17 !== -1 && index18 !== -1 && index18 === index17 + 1) {
  this.state.kits.splice(
    index17 + 1,
    0,
    { count: 26, path: 200 },
    { count: 43, path: 300 }
  );
}

  // Remove any existing entry with path: 100
  const index100 = this.state.kits.findIndex(k => k.path === 100);
  if (index100 !== -1) {
    this.state.kits.splice(index100, 1);
  }

  // Find index of path 47
  const index47 = this.state.kits.findIndex(k => k.path === 47);
  // Find index of path 48
  const index48 = this.state.kits.findIndex(k => k.path === 48);

  // Insert between path 47 and 48
  if (index47 !== -1 && index48 !== -1 && index48 === index47 + 1) {
    this.state.kits.splice(index47 + 1, 0, { count: 1, path: 100 }); // Adjust count as needed
  }

    return(



      <div style={{textAlign: 'center' }}>
      <div style={{ height: '30px' }}></div>
	<div className="mytitlepartidos"> Camisetas utilizadas desde 1998 </div>
      <div style={{textAlign: 'center' }}>
	<div style={{ height: '20px' }}></div>
      <Image  className="myescudo-away-main"  src={'/images/escudos/udeconce.png'}/>
      </div>

      <div style={{ height: '50px' }}></div>

	<div style={{ height: '50px' }}></div> 


<div style={{ display: 'inline-block' }}>
  <table style={{ textAlign: 'center'}}>
    {
      // Split kits into rows of 5
      [...Array(Math.ceil(this.state.kits.length / 5))].map((_, rowIndex) => {
        const rowItems = this.state.kits.slice(rowIndex * 5, rowIndex * 5 + 5);
        return (
          <React.Fragment key={rowIndex}>
            <tr>
              {rowItems.map(i => (
                <td key={`img-${i.path}`} style={{ padding: '10px 15px' }}>
                  <Image className="escudo-home" src={this.state.kit_path + i.path + ".png"} />
                </td>
              ))}
            </tr>
            <tr>
              {rowItems.map(i => (
                <td key={`count-${i.path}`} className="circle"  >
                  {i.count}
                </td>
              ))}
            </tr>
		<tr>
          <td colSpan={5} style={{ height: '30px' }}></td>
        </tr>
          </React.Fragment>
        );
      })
    }
  </table>
</div>


<div style={{ height: '70px' }}></div>





        
        <div style={{ height: '70px' }}></div>

     </div>

    )

}
}
export default Camisetas;
